import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/header";
import BottomDock from "./components/BottomDock";
import DynamicTitle from "./components/DynamicTitle";
import Footer from "./components/footer";
import ScrollToTop from "./components/ScrollToTop";
import StructuredData from "./components/StructuredData";
import ProjectScrollProgress from "./components/Project/ProjectScrollProgress";
import { NavProvider } from "./context/NavContext";
import { ProjectTOCProvider } from "./context/ProjectTOCContext";
import { ThemeProvider } from "./context/ThemeContext";
import appRoutes from "./routes";
import lazyWithSkeleton from "./utils/lazyWithSkeleton";
import NotFoundPageSkeleton from "./components/Skeleton/NotFoundPageSkeleton";

const CookieConsent = lazy(() => import("./components/CookieConsent"));
const NotFound = lazyWithSkeleton(
  () => import("./pages/NotFound"),
  NotFoundPageSkeleton
);

function App() {
  return (
    <Router>
      <ThemeProvider>
        <NavProvider>
          <ProjectTOCProvider>
          <DynamicTitle />
          <ScrollToTop />
          <StructuredData />
          <ProjectScrollProgress />
          <div className="app-container">
            <Navbar />
            <main className="content">
              <Suspense fallback={null}>
                <Routes>
                  {appRoutes.map(({ path, Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                  ))}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
            <BottomDock />
            <Suspense fallback={null}>
              <CookieConsent />
            </Suspense>
          </div>
          </ProjectTOCProvider>
        </NavProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
